export default __webpack_public_path__ + "static/media/XpatsoAppleApp2.af238ab1.png";